module.exports = __webpack_public_path__ + "img/sex_ed_logo.39fd5464.png";